<template>
	<form class="popup" @submit.prevent="submit">
		<table class="popup__table">
			<tr>
				<th>번호</th>
				<td>
					{{
						mode === 'register' ? '자동생성' : $route.params.idPopup
					}}
				</td>
			</tr>
			<tr>
				<th>팝업배너명</th>
				<td>
					<label>
						<input v-model="popupTitle" type="text" />
					</label>
					<p>내부 관리를 위한 제목 입력란입니다.(유저에게 미노출)</p>
				</td>
			</tr>

			<tr>
				<th>노출순서</th>
				<td>
					<input v-model="sort" type="number" style="width: 5em" />
				</td>
			</tr>

			<tr>
				<th>시작일시</th>
				<td>
					<DateBox v-model="startDate" />
				</td>
			</tr>
			<tr>
				<th>종료일시</th>
				<td>
					<RadioList
						:value="isInfinite"
						:radioList="isInfiniteList"
						@input="hanldeIsInfiniteList"
					/>
					<DateBox v-show="isInfinite === 1" v-model="endDate" />
				</td>
			</tr>
			<tr>
				<th>팝업 이미지</th>
				<td>
					<image-uploader
						ref="imageUploader_1125x720"
						group="init-popup"
						:image-size-limit="{
							width: 1125,
							height: 720,
							previewWidth: 300,
							type: 'fit',
						}"
						@upload="onImageUpload($event, '1125x720')"
						:file-path-has-slash="true"
					/>
					<p>
						- 파일형식: PNG(*.png), JPEG(*.jpg) <br />
						- 사이즈: 1125 x 720
					</p>
				</td>
			</tr>
			<tr>
				<th>링크 설정</th>
				<td>
					<RadioList v-model="isLink" :radioList="isLinkList" />
					<div
						v-show="isLink === 1"
						class="popup__table__link-wrapper"
					>
						<label>
							<select
								class="popup__table__link-type"
								v-model="linkType"
							>
								<option
									v-for="item in linkTypeList"
									:key="item.id"
									:value="item.id"
								>
									{{ item.name }}
								</option>
							</select>
						</label>
						<label>
							<input
								type="text"
								v-model="linkValue"
								placeholder="링크값을 입력하세요"
							/>
						</label>
						<p>
							- 시작팝업에 링크를 설정하는 경우, 팝업의 내용
							영역(전체)을 누르면 시작팝업이 닫히면서 연결
							화면으로 이동합니다.
						</p>
					</div>
				</td>
			</tr>
		</table>

		<div class="popup__button-wrapper">
			<button
				type="submit"
				class="btn btn-blue"
				v-text="mode === 'register' ? '등록' : '수정'"
			/>
			<button
				type="button"
				class="btn"
				v-text="'입력값 초기화'"
				@click="initInputs"
			/>
		</div>
	</form>
</template>
<script>
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import { getIdRegister } from '@/util';
	import DateBox from '@/components/DateBox';
	import ImageUploader from '@/components/ImageUploader';
	import RadioList from '@/components/RadioList.vue';

	export default {
		name: 'Popup',
		components: {
			DateBox,
			ImageUploader,
			RadioList,
		},
		props: {
			mode: {
				type: String,
				default: 'register',
			},
		},
		data() {
			return {
				popupTitle: '',
				startDate: '',
				endDate: '',
				isInfinite: 0,
				isInfiniteList: [
					{ id: 0, value: '미정' },
					{ id: 1, value: '설정' },
				],
				isLink: 0,
				isLinkList: [
					{ id: 0, value: '링크 없음' },
					{ id: 1, value: '링크 연결' },
				],
				linkType: null,
				linkValue: '',
				doc: {
					image_path: {},
				},
				s3Key: '',
				sort: 0,
			};
		},
		mounted() {
			if (this.mode === 'modify') {
				const idPopup = this.$route.params.idPopup;

				this.$axiosAdmin2
					.get(`/api/popup/${idPopup}`)
					.then(({ data }) => {
						this.popupTitle = data.popupTitle;
						this.isInfinite = data.isInfinite;
						this.isLink = data.isLink;
						this.linkType = data.linkType.toString();
						this.linkValue = data.linkValue;
						this.startDate = data.startDate
							? moment(
									data.startDate,
									'YYYY-MM-DD HH:mm:ss'
								).format('YYYY-MM-DDTHH:mm')
							: '';
						this.endDate = data.endDate
							? moment(
									data.endDate,
									'YYYY-MM-DD HH:mm:ss'
								).format('YYYY-MM-DDTHH:mm')
							: '';
						this.sort = data.sort;

						if (data.doc) {
							this.doc = JSON.parse(data.doc);
							this.$refs.imageUploader_1125x720.setImageByUrl(
								'https://dn5hzapyfrpio.cloudfront.net' +
									this.doc.image_path['1125x720']
							);
						}
					})
					.catch(e => {
						console.error(e);
					});
			}
		},
		computed: {
			...mapGetters(['getListAddNull']),
			linkTypeList() {
				return this.getListAddNull('newLinkType');
			},
		},
		methods: {
			onImageUpload(event, key) {
				if (!Object.keys(event).length) return;
				this.doc.image_path[key] =
					event.fileDir + '/' + event.fileSaveName;
			},
			initInputs() {
				this.popupTitle = '';
				this.startDate = '';
				this.endDate = '';
				this.isInfinite = 0;
				this.isLink = 0;
				this.linkType = null;
				this.linkValue = '';
			},
			initEndDate() {
				this.endDate = '';
			},
			hanldeIsInfiniteList(value) {
				this.isInfinite = value;
				this.initEndDate();
			},
			isEmpty(target) {
				return !target || target.toString().trim().length === 0;
			},
			validation() {
				if (this.isEmpty(this.popupTitle)) {
					alert('팝업제목을 입력해주세요.');
					return false;
				}

				if (!this.startDate) {
					alert('시작일시를 설정해주세요.');
					return false;
				}

				if (this.isInfinite === 1) {
					if (!this.endDate) {
						alert('종료일시를 설정해주세요.');
						return false;
					}

					if (this.startDate > this.endDate) {
						alert('종료일시는 시작일시보다 빠를 수 없습니다.');
						return false;
					}
				}

				if (
					this.mode === 'register' &&
					!this.$refs.imageUploader_1125x720.previewImage.src
				) {
					alert('팝업이미지 1125x720를 등록해주세요.');
					return false;
				}

				if (this.isLink === 1) {
					if (this.isEmpty(this.linkType)) {
						alert('링크종류를 선택해주세요.');
						return false;
					}

					if (this.isEmpty(this.linkValue)) {
						alert('링크값을 입력해주세요.');
						return false;
					}
				}

				return true;
			},
			submit() {
				if (!this.validation()) {
					return false;
				}

				let confirmMessage = '';
				let completeMessage = '';

				if (this.mode === 'register') {
					confirmMessage = '등록하시겠습니까?';
					completeMessage = '새로운 시작팝업이 등록완료되었습니다.';
				} else if (this.mode === 'modify') {
					confirmMessage = '수정하시겠습니까?';
					completeMessage = '시작팝업이 수정완료되었습니다.';
				}

				if (!confirm(confirmMessage)) {
					return false;
				}

				const data = {
					popupTitle: this.popupTitle,
					startDate: moment(
						this.startDate,
						'YYYY-MM-DDTHH:mm'
					).format('x'),
					endDate: this.endDate
						? moment(this.endDate, 'YYYY-MM-DDTHH:mm').format('x')
						: null,
					isInfinite: this.isInfinite,
					isLink: this.isLink,
					linkType: this.linkType,
					linkValue: this.linkValue,
					sort: this.sort,
					idRegister: getIdRegister(),
					image1125x720: this.doc.image_path['1125x720'],
				};

				if (this.mode === 'modify') {
					data.idPopup = this.$route.params.idPopup;
				}

				this.$store.commit('toggleSpinner', true);

				this.$axiosAdmin2
					.post('/api/popup/save', data)
					.then(({ data }) => {
						if (data.resultCode === 'success') {
							alert(completeMessage);
							this.$router.push(
								'/advertisement/init-popup/management'
							);
						}

						this.$store.commit('toggleSpinner', false);
					})
					.catch(({ response }) => {
						alert('서버와 통신중 문제가 발생했습니다.');
						console.error(response);

						this.$store.commit('toggleSpinner', false);
					});
			},
		},
	};
</script>

<style lang="scss">
	.vdp-datepicker__calendar {
		padding-top: 1.5em;
	}
</style>
<style lang="scss" scoped>
	.popup__table {
		table-layout: fixed;

		th,
		td {
			border-bottom: 1px solid #ebebed;
			padding: 1em;
		}

		th {
			width: 10%;
			background: #f4f7fa;
			color: #657088;
			text-align: right;
		}

		p {
			padding: 1em 0;
		}

		label {
			margin-right: 1.5em;
		}
	}

	.popup__table__datepicker {
		display: inline-block;
		width: 100px;
	}

	.popup__table__image-wrapper {
		text-align: center;

		img {
			width: 300px;
			cursor: pointer;
		}
	}

	.popup__table__button-wrapper {
		text-align: right;

		button {
			display: inline-block;
		}
	}

	.popup__table__link-wrapper {
		padding: 1em 0;

		label {
			display: block;
			margin-bottom: 1em;

			&:last-child {
				margin-bottom: 0;
			}
		}
	}

	.popup__table__link-type {
		height: 35px;
		background: #fff;
		border: solid 1px #dfe6ee;
	}

	.popup__button-wrapper {
		padding: 2em;
		text-align: center;

		.btn {
			display: inline-block;
			min-width: 100px;
		}

		.btn-blue {
			background: $btn-blue;
			border: 1px solid $btn-blue;
			color: #fff;
		}
	}
</style>
